import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconButton, Grid } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { editExpense, deleteExpense, selectExpenseById } from "./expensesSlice";
import { selectTotalById } from "./totalsSlice";
import { LineItem } from "../common/LineItem";

export const Expense = ({ id }) => {
	const dispatch = useDispatch();
	const expense = useSelector(state => selectExpenseById(state, id));
	const rooms = useSelector(state => selectTotalById(state, 0)).value;

	const formatExpense = ({ type, expense, amount, percent, marginal, fixed }) => {
		return [
			{label: "expense", value: expense},
			{label: "amount", value: amount, adornment: "$"},
			...(percent !== undefined ? [{label: "percent", value: percent, endAdornment: "%"}] : []),
			...(marginal !== undefined ? [{label: "marginal", value: marginal, adornment: "$", readOnly: type !== "variable"}] : []),
			...(fixed !== undefined ? [{label: "fixed", value: fixed, adornment: "$", readOnly: true}] : [])
		];
	};

	const onChange = (e, label) => {
		const value = label === "expense" ? e.target.value : e.target.value === "" ? 0.00 : parseFloat(e.target.value.replace(/,/g, ""));
		dispatch(editExpense({id, changes: {[label]: value}}));
	};

	const remove = (id) => {
		dispatch(deleteExpense(id));
	};

	useEffect(() => {
		const { type, amount, percent } = expense;
		if(expense.type !== "fixed") {
			const variable = percent !== undefined ? percent : 0.00;

			const marginalCalc = rooms > 0 ? (amount / rooms) : 0.00;
			const marginal = type === "mixed" ? marginalCalc * (variable / 100) : marginalCalc;
			const fixed = percent !== undefined ? ((amount / rooms)*(1-(variable / 100))) : undefined;

			dispatch(editExpense({id, changes: {marginal: marginal > 0 ? marginal : 0.00, fixed}}));
		}
	}, [rooms, expense.amount, expense.percent]);

	return (
		<Grid container item spacing={1}>
			<Grid container item spacing={1} xs>
				{formatExpense(expense).map(({ label, value, adornment, endAdornment, readOnly }, key) =>
					<Grid key={`expense_${key}`} item xs={
						label === "expense" && expense.type === "variable" ? 6 :
						label === "expense" && expense.type === "mixed" ? 4 :
						label === "expense" && expense.type === "fixed" ? 8 :
						expense.type === "variable" ? 3 :
						expense.type === "fixed" ? 4 : 2

					}>
						<LineItem {...{label, onChange, value, adornment, endAdornment, readOnly}} />
					</Grid>
				)}
			</Grid>
			<Grid item sx={{display: "flex", justifyContent: "center"}}>
				<IconButton sx={{border: "1px solid"}} color="error" onClick={() => remove(id)}><Delete/></IconButton>
			</Grid>
		</Grid>
	);
};